import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { redirectBackToPayment } from '../utils/AddNewCardUtils';
import GlobalPaymentCreditDebitCardForm from 'organisms/Payment/Forms/GlobalPaymentCreditDebitCardForm';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { GLOBAL_PAYMENTS_SCRIPT_URL } from '@kfc-global/react-shared/config/config.constants';
import { loadScript } from 'common/utilities/utils';
import {
  getPaymentProviderPlaceOrderBtn,
  dispatchGlobalPaymentsGenerateToken,
} from 'organisms/Payment/utils/GlobalPaymentUtils';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
const { GLOBAL_PAYMENTS_CONSTANTS } = PAYMENT_CONSTANTS;

const GlobalPaymentAddCardTemplate = props => {
  const { paymentDetails, updateSaveCardDetails } = props;
  const history = useHistory();
  const params = { checkoutDetails: paymentDetails, updateCheckoutDetails: updateSaveCardDetails, history };

  useEffect(() => {
    updateSaveCardDetails({
      enablePaymentProviderPlaceOrderBtn: true,
      paymentProviderPlaceOrderBtn: getPaymentProviderPlaceOrderBtn,
    });
    dispatchGlobalPaymentsGenerateToken(paymentDetails, updateSaveCardDetails, params);
    loadScript(config(GLOBAL_PAYMENTS_SCRIPT_URL), GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_SCRIPT_ID);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {window?.GlobalPayments && <GlobalPaymentCreditDebitCardForm {...params} fromAccountpage={true} />}

      <div className='row globalpayment-add-new-card'>
        <div className='col-sm-4 col-12'>
          <div id='add-new-card-cont'>
            <div id={`payment-place-order-cont`}>{getPaymentProviderPlaceOrderBtn(params)}</div>
            <div
              id='payment-provider-place-order-form'
              className={`${
                !(
                  paymentDetails?.paymentCardDetails?.isFormValid &&
                  paymentDetails?.billingAddressAndSaveCard?.isBillingAddressFormDetailsValid
                )
                  ? 'addCardInValid'
                  : ''
              }`}
            ></div>
          </div>
        </div>
        <div className='col-sm-4 col-12'>
          <div className='add-cancel-button'>
            <div
              className='mt-10 button font-bold whiteButton blackBorder'
              data-testid='add-cancel-button'
              onClick={() => redirectBackToPayment(history)}
            >
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CANCEL)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalPaymentAddCardTemplate;
